import React from 'react';

import { DOMAINS } from '../../constants';
import { User } from '../../useUser';

import { fireGTMMetric } from './GoogleMetrics';

const getUserGTMMetricsMetadata = async (user) => {
    let userMetadata: {
        fgb_id: string;
        is_bot: boolean;
        is_fgb: boolean;
        is_vip: boolean;
        user_id: number | null;
    } = {
        fgb_id: '',
        is_bot: false,
        is_fgb: false,
        is_vip: false,
        user_id: null,
    };
    if (user.isLoggedIn) {
        userMetadata = {
            ...userMetadata,
            is_fgb: DOMAINS.some((str) => user.email.includes(str)),
            is_vip: !!user.isVip,
            user_id: user.id,
        };
    }
    const Cookies = (await import('js-cookie')).default;
    userMetadata.fgb_id = Cookies.get('FGB_ID');
    userMetadata.is_bot = !!user.isBot;
    return userMetadata;
};

const fireGTMPageViewMetric = async (pagePath, pageTitle, user) => {
    const userGTMMetadata = await getUserGTMMetricsMetadata(user);
    fireGTMMetric('page-view', pagePath, pageTitle, userGTMMetadata);
};

export const GoogleMetricTracer = (props: {
    pagePath: string | null;
    pageTitle: string;
    user?: User | null;
}) => {
    const { pagePath = null, pageTitle = null, user = null } = props;
    React.useEffect(() => {
        fireGTMPageViewMetric(pagePath, pageTitle, user);
    }, []);

    return null;
};
